export default {
  workspaceFeedIsApproved(state) {
    return state.workspaceFeedIsApproved;
  },
};
